<template>
  <div class="bg-more">
    <section class="jumbotron jumbotron-fluid bg-cover-top bg-img-height-m font-KaushanScript" :style="{ backgroundImage: 'url(' + contactBg + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-md-5 d-none d-md-block">
            <div class="d-flex flex-column align-items-start">
              <h1 class="text-primary font-weight-bold pt-5 font-size-xl">Contact us</h1>
            </div>
          </div>
          <div class="col-md-5 d-md-none">
            <div class="text-center text-shadow mt-4 pt-2">
              <h1 class="text-primary font-weight-bold font-size-xl">Contact us</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container pb-5">
      <div class="d-flex align-items-center map-box">
        <div class="form-row justify-content-center" style="width: 100%; ">
          <div class="col-md-12">
            <div class="d-flex flex-column justify-content-center">
              <p
                class="font-weight-bold text-secondary text-center pt-3 px-3 d-none d-md-block
            font-size-l"
              >
                {{ $t("contact.mapTitleFormat") }}
              </p>
              <p
                class="font-weight-bold text-secondary text-center pt-3
            px-3 d-md-none font-size-m-plus"
              >
                {{ $t("contact.mapTitleFormat") }}
              </p>

              <div class="form-row mt-2">
                <div class="col-md">
                  <p class="text-more px-md-2">
                    {{ $t("contact.mapTextFormat") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="map-body" id="map" ref="map"></div>
          
          </div>
        </div>
      </div>
    </section>
    <!-- 聯絡我們 -->
    <section class="contact bg-light py-5">
      <div class="container-Contact">
        <h2 class="text-center font-weight-bold mb-3">{{ $t("contact.contactFromFormat.titleFormat") }}</h2>
        <p class="text-center">
          {{ $t("contact.contactFromFormat.contentFormat") }}
        </p>
        <validation-observer v-slot="{ invalid }">
          <form class="contactForm">
            <!-- Name -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required" v-slot="{ errors, classes, passed }">
                <label for="name" class="mb-2"><span class="text-danger">*</span>{{ $t("contact.formFormat.nameFormat") }}</label>
                <input
                  type="name"
                  class="form-control rounded-0"
                  id="name"
                  name="姓名"
                  v-model.trim="form.name"
                  :class="classes"
                  :placeholder="$t('contact.formFormat.namePlaceholder')"
                />
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("contact.formFormat.namePlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("contact.formFormat.namePassed") }} </span>
              </validation-provider>
            </div>
            <!-- phone -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required|min:8" v-slot="{ errors, classes, passed }">
                <label for="phone" class="mb-2"> <span class="text-danger">*</span> {{ $t("contact.formFormat.phoneFormat") }}</label>
                <input
                  type="phone"
                  class="form-control rounded-0"
                  id="phone"
                  name="電話"
                  v-model.trim="form.phone"
                  :class="classes"
                  :placeholder="$t('contact.formFormat.phonePlaceholder')"
                />
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("contact.formFormat.phonePlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("contact.formFormat.phonePassed") }}</span>
              </validation-provider>
            </div>
            <!-- Mail -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required|email" v-slot="{ errors, classes, passed }">
                <label for="email" class="mb-2"> <span class="text-danger">*</span> {{ $t("contact.formFormat.emailFormat") }}</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="Email"
                  v-model.trim="form.email"
                  :class="classes"
                  :placeholder="$t('contact.formFormat.emailPlaceholder')"
                />
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("contact.formFormat.emailPlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("contact.formFormat.emailPassed") }}</span>
              </validation-provider>
            </div>
            <!-- content -->
            <div class="form-group contactFormGroup">
              <validation-provider rules="required" v-slot="{ errors, classes, passed }">
                <label for="content" class="mb-2"><span class="text-danger">*</span> {{ $t("contact.formFormat.contentFormat") }}</label>
                <textarea
                  class="form-control"
                  id="content"
                  name="留言"
                  rows="10"
                  v-model.trim="form.content"
                  :class="classes"
                  :placeholder="$t('contact.formFormat.contentPlaceholder')"
                >
                </textarea>
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("contact.formFormat.contentPlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback">{{ $t("contact.formFormat.contentPassed") }}</span>
              </validation-provider>
            </div>
            <!-- Checkbox -->
            <div class="form-check contactFormGroup ">
              <validation-provider :rules="{ required: { allowFalse: false } }" v-slot="{ errors, classes, passed }">
                <input
                  type="checkbox"
                  id="privacy"
                  name="隱私權政策"
                  class="mb-2 form-check-input privacy"
                  v-model.trim="form.privacy"
                  :class="classes"
                />
                <label for="privacy">
                  {{ $t("contact.formFormat.privacyMsg") }}
                </label>
                <span v-if="errors[0]" class="invalid-feedback">{{ $t("contact.formFormat.privacyMsgPlaceholder") }}</span>
                <span v-if="passed" class="valid-feedback"> {{ $t("contact.formFormat.privacyPassed") }} </span>
              </validation-provider>
            </div>
            <!-- Submit -->
            <div class="form-group row d-flex justify-content-center mt-5">
              <div class="col-md-4 mt-3 mt-md-0">
                <button
                  type="button"
                  :disabled="invalid"
                  @click="contactSubmit"
                  class="btn btn-secondary btn-block d-flex align-items-center
                  justify-content-center"
                >
                  {{ $t("contact.submitFormat.btnFormat") }}
                </button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
      <!-- contact Modal -->
      <div id="contactModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header bg-secondary">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-light text-center">
              <div class="h5 text-info font-weight-bold">感謝您的聯繫</div>
              <div class="h5 text-info font-weight-bold">我們將盡快與您聯絡！</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import contactBg from "@/assets/img/contact-bg.png";
import contactBg2 from "@/assets/img/contact-bg2.png";

export default {
  data() {
    return {
      contactBg,
      contactBg2,
      form: {
        name: "",
        phone: "",
        email: "",
        content: "",
        type: 1,
        privacy: false,
      },
      map: null, // 地图实例
      marker: null, // 标记实例
    };
  },
  mounted() {
    // 使用 $nextTick 确保 DOM 更新后再初始化地图
    this.$nextTick(() => {
      this.initMap();
    });
  },
  methods: {
    contactSubmit() {
      const url = `${process.env.VUE_APP_APIPATH}//shop/v1/lifa/sub`;
      $("#contactModal").modal("show");
      this.$http
        .post(url, { ...this.form })
        .then((res) => {
          $("#contactModal").modal("hide");
        })
        .catch((error) => {
          $("#contactModal").modal("hide");
        });
    },
    initMap() {
      // 确保地图容器的大小有效
      const mapContainer = this.$refs.map;
      if (!mapContainer || mapContainer.offsetWidth === 0 || mapContainer.offsetHeight === 0) {
        console.error("地图容器尺寸无效");
        return;
      }

      // 初始化地图
      this.map = new AMap.Map(mapContainer, {
        center: [113.549208, 22.188374], // 设置地图中心为北京的坐标
        zoom: 15, // 设置缩放级别
      });

      // 创建一个标记，设置固定的经纬度位置
      this.marker = new AMap.Marker({
        position: [113.549208, 22.188374], // 设置标记的固定位置
      });

      // 将标记添加到地图上
      this.marker.setMap(this.map);
    },
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .map-box {
    flex-direction: column;
  }
  .map-body {
    margin-right: 0 !important;
    height: 250px !important;
  }
  .container-Contact {
    width: 90%;
  }
}
.map-body {
  margin-right: 20px;
  width: 100%;
  height: 450px;
 
}
</style>
